import { ReactNode } from 'react';

import { cn } from '@/utils/cn';

export interface PlanStat {
    label: string;
    value: ReactNode;
    title?: string;
}

/** The Withdrawal Plan's summary figures, shown in the section header and in the Manage modal. */
export const PlanStats = ({ stats, className }: { stats: PlanStat[]; className?: string }) => (
    <dl className={cn('flex flex-wrap items-start gap-8', className)}>
        {stats.map((stat) => (
            <div key={stat.label} title={stat.title}>
                <dt className="text-cocoa-500 text-[13px]">{stat.label}</dt>
                <dd className="text-cocoa-1000 mt-1 flex items-center gap-2 text-lg font-medium tabular-nums">
                    {stat.value}
                </dd>
            </div>
        ))}
    </dl>
);
